


























































































































import { Component, Vue } from "vue-property-decorator";
import TheTemplateH from "@/general/components/templates/TheTemplateH.vue";
import TheHDetail from "@/general/components/pages/parts/PointHistoryList/layout/TheHDetail.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";
import SmallText from "@/common/components/atoms/SmallText.vue";
import IconUserImage from "@/common/components/icons/IconUserImage.vue";
import HContainer from "@/general/components/pages/parts/PointHistoryList/HContainer.vue";
import HGivePointPageIcon from "@/general/components/pages/parts/PointHistoryList/page-of-give-the-point/HGivePointPageIcon.vue";
import commons from "@/common/store/modules/commons";
import globals from "@/general/store/modules/globals";
import { getTransactionThanksgivingDetail } from "@/general/store/api";
import {
  getQueryString,
  setQueryString
} from "@/common/assets/js/utils/queryParams";
import { formatUTCDate } from "@/common/assets/js/utils/dateFormat";
import { PointHistoryGiftInfo, UserInfo } from "@/general/store/models";
import CONST_DATA from "@/general/mixins/const/constData";
import auth from "@/general/store/modules/auth";
import { getApprovalStatusLabel } from "@/common/assets/js/utils/types";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import LocalStorage from "@/general/utils/storage";
import AuthStorage from "@/general/utils/auth";
import AuthApi from "@/general/api/authApi";

@Component({
  components: {
    TheHDetail,
    TextLabel,
    SmallText,
    IconUserImage,
    TheTemplateH,
    HContainer,
    HGivePointPageIcon
  }
})
export default class PointHistoryGift extends Vue {
  giveData: any = {};

  userInfo: UserInfo;

  avatar = "";

  get givePoint() {
    return {
      point: this.giveData.point.give,
      sign: this.giveData.point.added
    };
  }

  get userIcon() {
    //#59042対応によりセッション情報からavatarを取得するように修正
    //return this.userInfo?.avatar;
    return this.avatar;
  }

  async setPageData() {
    const breadcrumb = [
      {
        text: "",
        url: CONST_DATA.SITE_MAP.TOP_PAGE,
        pageType: "home"
      },
      {
        text: "ポイント確認",
        url: `${CONST_DATA.SITE_MAP.POINT_CONFIRMATION}?${getQueryString({
          ...this.params,
          id: undefined
        })}`,
        pageType: "lower"
      },
      {
        text: " ポイント詳細",
        url: "",
        pageType: "lower"
      }
    ];

    await commons.getBreadcrumb(breadcrumb);
  }

  params = {
    id: "",
    transaction_direction: "",
    transaction_type: "",
    filter_position: "",
    refine_position: "",
    ordering: "",
    page: "1",
    search: ""
  };

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const queries = [
      { k: "id" },
      { k: "transaction_direction" },
      { k: "transaction_type" },
      { k: "filter_position" },
      { k: "refine_position" },
      { k: "ordering", v: "-created_at" },
      { k: "page", v: 1 },
      { k: "search" }
    ];

    this.params = setQueryString(this.params, queries);
    await this.setPageData();

    this.userInfo = auth.user;
    await this.retrieveGrantPointDetails(
      parseInt(this.params.id), 
      this.params.transaction_direction
    );

    //#59042対応によりセッション情報からavatarを取得するように修正
    await AuthApi.getICSession()
    .then((result) => {
        const ic_session = JSON.parse(result);
        this.avatar = ic_session.avatar;
    })
    .catch(() => {
      this.avatar = "";
    });
  }

  async retrieveGrantPointDetails(id: number, transaction_direction: string) {
    const response: PointHistoryGiftInfo = await getTransactionThanksgivingDetail(
      id,
      transaction_direction
    );

    if (typeof response === "undefined" || response.status == "404") {
      window.location.href = "/error-not-found";
    }

    const { from_user, to_user } = response;

    const state = this.userInfo?.user_id === from_user.id ? "given" : "give";
    const added = state === "give" ? true : false;
    const user = state === "give" ? from_user : to_user;
    const title =
      state === "give" ? this.thanksPointName + "受贈" : this.thanksPointName + "贈与";

    const give_to = user?.last_name + " " + user?.first_name;
    
    let expirationList = [];
    if(response?.expiresList.length === 1){
      let expirationTmp = {label : "有効期限", date : formatUTCDate(response?.expires_at)};
      expirationList.push(expirationTmp);
    }else{
      for(var i = 0; i < response?.expiresList.length; i++){
        let expirationTmp = {label : "有効期限", date : formatUTCDate(response?.expiresList[i][0]) + "（" + response?.expiresList[i][1] + commons?.OrgPageSpecific?.point_name + "）"};
        expirationList.push(expirationTmp);
      }
    }

    // DX_IC-942
    this.giveData = {
      title,
      give_details: {
        image: user.id == 0 ? "" : user?.user_image,
        give_id: {
          label: "贈与ID",
          id: response?.pk
        },
        give_to,
        group_name: user?.group_name,
        // DX_IC-628 グループコード表示追加
        group_code: user?.group_code,
        message: {
          title: response?.title,
          text: response?.message,
          url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${response?.pk}`
        },
        dateLabel: state === "given" ? "贈与日" : "受贈日",
        date: this.$dayjs
          .utc(
            response?.status === "approved"
              ? response?.approved_or_rejected_at
              : response?.created_at
          )
          .locale("ja")
          .format("YYYY/MM/DD")
      },
      approved: response?.status,
      point: {
        state,
        added,
        give: response?.points,
        expiration: expirationList
      }
    };
    // DX_IC-942
    const messageArticleDetail = {
      id: user?.id,
      name: give_to,
      date: response?.status === "approved"
        ? response?.approved_or_rejected_at
        : response?.created_at,
      content: response?.message,
      url: `${CONST_DATA.SITE_MAP.THANKS_POINT_MESSAGES}?id=${response?.pk}`,
      icon: {
        original: "",
        large: "",
        medium: user?.user_image,
        small: ""
      },
      point: {
        total: response?.points,
        pointAddition: false,
        state
      },
      unread: response?.has_read === false && state !== "give" ? true : false
    };

    LocalStorage.setItem(
      "messageCardDetails",
      JSON.stringify(messageArticleDetail)
    );
  }

  get approvedLabel() {
    const { approved } = this.giveData;
    if (typeof approved === "undefined") return -1;
    return getApprovalStatusLabel(approved);
  }

  get title() {
    return this.giveData.title;
  }

  get giveId() {
    return this.giveData.give_details.give_id;
  }

  get giveDetails() {
    return this.giveData.give_details;
  }

  get image() {
    return this.giveData.give_details.image;
  }

  get message() {
    return this.giveData.give_details.message;
  }

  get approved() {
    return this.giveData.approved;
  }
  get point() {
    return this.giveData.point;
  }
  get userImageSize() {
    const { isSpScreenWidth } = globals;
    return isSpScreenWidth ? 72 : 138;
  }
  get approvalEnabled() {
    return auth.user.thanks_point_approval_enabled;
  }
  get messsageThreadEnabled() {
    return auth.user.thread_enabled;
  }

  get isSp() {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get headerHeight(): number {
    // ランク利用表示フラグを見てヘッダーの高さを変える
    if(commons.userInfo.rankDisplayEnabled === true) {
      return 135;
    }
    return 105;
  }
  get addMarginTop(): any {
    const style = {
      marginTop: this.headerHeight.toString() + "px"
    };
    return this.isSp ? style : "";
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }
}
